export default __webpack_public_path__ + "static/media/check.d962e2fc.svg";